import { PSection, PBox, PH1, PText } from "../theme/BaseTheme";
import { Tag } from "antd";
import { Link } from "react-router-dom";

const filters = [
    { name: "Comic", path: "/ai-comic-filter" },
    { name: "Ghibli", path: "/ai-ghibli-filter" },
    { name: "Manga", path: "/ai-manga-filter" },
    { name: "Oil Painting", path: "/ai-oil-painting-filter" },
    { name: "Pixel Art", path: "/ai-pixel-art-filter" },
    { name: "Rick And Morty", path: "/ai-rick-and-morty-filter" },
    { name: "Rococo", path: "/ai-rococo-filter" },
    { name: "Simpson", path: "/ai-simpson-filter" },
];

const ExploreFilters = () => {
    return (
        <PSection css={styles}>
            <PBox className="filters">
                <PBox className="filters-container">
                    <PText className="filters-subtitle">
                        Transform Your Photos
                    </PText>
                    <PH1 className="filters-title">
                        Explore More AI Image Filters
                    </PH1>
                    <PBox className="filters-wrapper">
                        {filters.map((filter) => (
                            <Link key={filter.path} to={filter.path}>
                                <Tag>{filter.name} Filter</Tag>
                            </Link>
                        ))}
                    </PBox>
                </PBox>
            </PBox>
        </PSection>
    );
};

const styles = {
    fontFamily:
        "Inter var, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    "& .filters": {
        padding: "2rem 1.5rem 0.5rem 1.5rem",
        maxWidth: "64rem",
        margin: "0 auto",
        "@bp2": { padding: "3rem 1.5rem 0.5rem 1.5rem" },
        "@bp4": { padding: "3rem 4rem 0.5rem 4rem" },
    },
    "& .filters-container": {
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
    },
    "& .filters-subtitle": {
        color: "$colors$primary",
        lineHeight: "1.75rem",
        fontWeight: "600",
        fontSize: "1rem",
        textAlign: "center",
    },
    "& .filters-title": {
        color: "rgb(17 24 39)",
        fontWeight: "700",
        fontSize: "1.875rem",
        lineHeight: "2.5rem",
        marginTop: "0.5rem",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        "@bp2": { fontSize: "2.25rem", lineHeight: "3rem" },
    },
    "& .filters-wrapper": {
        position: "relative",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        paddingBottom: "0.5rem",
        maxWidth: "80rem",
        marginTop: "3rem",
        marginBottom: "3rem",
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        justifyContent: "center",
        "& a": {
            textDecoration: "none",
        },
        "& .ant-tag": {
            margin: 0,
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            cursor: "pointer",
            borderRadius: "2rem",
            backgroundColor: "white",
            border: "1px solid $colors$primary",
            color: "$colors$primary",
            transition: "all 0.2s ease",
            "&:hover": {
                backgroundColor: "$colors$primary",
                color: "white",
                transform: "translateY(-2px)",
            },
        },
    },
};

export default ExploreFilters;
